import { GAME_STATE, PLAYER_STATE } from '../constants/commonConstants';

// Compare authoritative snapshots, not animation booleans. Repeated snapshots
// are silent; a different card/action is audible even when the phase is unchanged.
export function gameActionSounds(previous, next) {
    if (!previous || !next || previous.roomId !== next.roomId) return [];
    const sounds = [];
    if (previous.gameState !== next.gameState) {
        if (next.gameState === GAME_STATE.playing) sounds.push('gameStartSound', 'shuffleSound');
        if (next.gameState === GAME_STATE.winDeclared) sounds.push('winDeclareSound');
        if (next.gameState === GAME_STATE.readyForNextMatch) sounds.push('showWinningSound');
    }
    if (previous.gameState === GAME_STATE.playing && next.gameState === GAME_STATE.playing) {
        const newDiscard = next.currentDiscardedCard?.cardId;
        const discarded = Boolean(newDiscard && newDiscard !== previous.currentDiscardedCard?.cardId);
        const pickedPhase = next.players?.some(player => {
            const old = previous.players?.find(p => p.playerId === player.playerId);
            return [PLAYER_STATE.pickedDeckCard, PLAYER_STATE.pickedDiscardedCard].includes(player.playerState) &&
                (old?.playerState !== player.playerState || old?.turnStartedUtc !== player.turnStartedUtc);
        });
        // React may batch a discarded-card pick and the following discard into
        // one render, so the transient pickedDiscardedCard phase is not always
        // observable. The old table card appearing in a player's picked-card
        // history is the authoritative evidence that the pick occurred.
        const oldDiscardId = previous.currentDiscardedCard?.cardId;
        const pickedPreviousDiscard = Boolean(oldDiscardId) && next.players?.some(player =>
            player.pickedCards?.some(card => card.cardId === oldDiscardId) &&
            !previous.players?.find(old => old.playerId === player.playerId)?.pickedCards?.some(card => card.cardId === oldDiscardId));
        if (pickedPhase || pickedPreviousDiscard || next.deckCardCount < previous.deckCardCount) sounds.push('pickCardSound');
        if (discarded) sounds.push('discardCardSound');
    }
    return sounds;
}
